import { render, staticRenderFns } from "./SetIcon.vue?vue&type=template&id=f399b578&scoped=true"
import script from "./SetIcon.vue?vue&type=script&lang=js"
export * from "./SetIcon.vue?vue&type=script&lang=js"
import style0 from "./SetIcon.vue?vue&type=style&index=0&id=f399b578&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_cy24jmswklxzc46cxvuobxvpsa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f399b578",
  null
  
)

export default component.exports